import React, { useEffect } from 'react';
import { useField } from 'formik';
import { FormField, FormHelp, Input, Label } from '@zillow/constellation';
import styled from 'styled-components';
import { useGetACHRoutingNumberQuery } from '../../../../../../../API/order/escrow/AchDisbursementAPI';
import { INVALID_ABA_NUMBER_ERROR } from '../../wires/formFields/WireABAField';

export const RoutingNumberField: React.FC<{ isReadOnly: boolean }> = ({ isReadOnly }) => {
  const [field, meta, helpers] = useField<string | undefined>({ name: 'value.account.routingNumber' });
  const { data: bank, isError: isRoutingNumberError } = useGetACHRoutingNumberQuery(field.value ?? '', {
    skip: field.value?.length !== 9,
  });

  useEffect(() => {
    if (isRoutingNumberError && !meta.error) {
      helpers.setError(INVALID_ABA_NUMBER_ERROR);
    }
  }, [field.value, meta.error, helpers, isRoutingNumberError]);

  return (
    <StyledFormField
      label={<Label>Routing Number</Label>}
      control={<Input {...field} autoComplete={'off'} required />}
      error={!!meta.error}
      description={<FormHelp>{meta.error ?? bank?.bankName}</FormHelp>}
      required
      readOnly={isReadOnly}
    />
  );
};

const StyledFormField = styled(FormField)`
  flex-basis: 33%;
  padding-right: 2rem;
`;
